import { Badge } from '@billy/design-system'
import { ReactElement } from 'react'

import { useQuickStartProgress } from '../../hooks/useQuickStartProgress'

export const QuickStartCountBadge = (): ReactElement | null => {
  const { incompleteStepsCount, isLoading } = useQuickStartProgress()

  if (!incompleteStepsCount || isLoading) {
    return null
  }

  return <Badge color="accent">{incompleteStepsCount}</Badge>
}
